import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}
const InitialState = {
  data: {},
  error: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        errors: [],
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        errors: action.payload.errors || null,
        data: action.payload.configuration || action.payload.data || {},
      }
    case FAILURE:
      return {
        ...state,
        errors: action.payload.errors,
        isLoading: false,
      }
    default:
      return state
  }
}

const usePostConfigurationReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default usePostConfigurationReducer
export {ActionTypes, InitialState, Reducer}
